import { Outlet, useNavigate } from 'react-router-dom';
import Header from './Header';
import Overlay from '../overlay/Overlay';
import './styles/Header.css'
import './styles/Footer.css'
import { useOverlay } from '../../context/OverlayProvider';
import Footer from './Footer';

export function Layout() {
  const navigate = useNavigate();
  const [{ content }] = useOverlay();

  return (
    <>
      <Header/>
      <Outlet />
      <Footer/>
      <Overlay>
        {content}
      </Overlay>
    </>
  );
}